import React from 'react'

import { AppUrls } from 'common/AppUrls'
import { ReactComponent as ContactsIcon } from 'assets/svg/footer/tab_contacts.svg'
import { ReactComponent as DialpadIcon } from 'assets/svg/footer/tab_dialpad.svg'
import { ReactComponent as RecentsIcon } from 'assets/svg/footer/tab_recents.svg'
import { ReactComponent as SettingsIcon } from 'assets/svg/footer/tab_settings.svg'
import { UrlsProvider } from 'utils/urlUtils'
import { ContactsPageTypes } from 'common/Enums'

export const FooterConfig = [
    {
        id: 0,
        name: 'Recents',
        url: AppUrls.recents,
        icon: <RecentsIcon width={18} />
    },
    {
        id: 1,
        name: 'Dialpad',
        url: AppUrls.dialpad,
        icon: <DialpadIcon width={16} />
    },
    {
        id: 2,
        name: 'Contacts',
        url: UrlsProvider.contactsUrlGenerator(ContactsPageTypes.AllContacts),
        icon: <ContactsIcon width={21} />
    },
    {
        id: 3,
        name: 'Settings',
        url: AppUrls.settings,
        icon: <SettingsIcon width={18} />
    }
]
